import { render, staticRenderFns } from "./ModalAddWYSIWYG.vue?vue&type=template&id=6fea1d66&"
import script from "./ModalAddWYSIWYG.vue?vue&type=script&lang=js&"
export * from "./ModalAddWYSIWYG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports